// extracted by mini-css-extract-plugin
export default {"button":"styles_button__1qX0y"};